import type { BusinessAnalytics } from '../types';

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getMockAnalytics(businessId: string): BusinessAnalytics {
  const seed = hashString(businessId);

  const plansThisMonth = 8 + (seed % 18);
  const participantsThisMonth = plansThisMonth * (4 + (seed % 5));

  return {
    plansThisMonth,
    participantsThisMonth,
    profileViewsThisMonth: 120 + (seed % 200),
    mapViewsThisMonth: 80 + (seed % 150),
    webClicksThisMonth: 12 + (seed % 30),
    instagramClicksThisMonth: 18 + (seed % 40),
    plansByMonth: [
      { label: 'Ene', value: 6 + (seed % 8) },
      { label: 'Feb', value: 8 + (seed % 10) },
      { label: 'Mar', value: 10 + (seed % 12) },
      { label: 'Abr', value: 9 + (seed % 11) },
      { label: 'May', value: 11 + (seed % 14) },
      { label: 'Jun', value: plansThisMonth },
    ],
  };
}
